// One outlet on a publication: where it ran, and everything specific to that paper
// — when it ran there, a link, and the clipping showing how it actually appeared.
//
// This card is the SINGLE place an outlet appears in the form. Selection, detail and
// clipping used to be separate lists of the same outlets; folding them together is
// what keeps ten papers readable.
import he from '../i18n/he';
import Button from './Button';
import { DateControl } from './DateField';
import { FileActions } from './FileList';

export default function OutletCard({
  outlet, label, clipping, canAttach, busy, onChange, onRemove, onAttach, onRemoveClipping,
}) {
  const set = (key) => (e) => onChange({ ...outlet, [key]: e.target.value || null });

  const pick = (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = ''; // let the same file be re-picked after a failure
    if (file) onAttach(file);
  };

  return (
    <div className={`outlet-card${clipping ? ' has-clipping' : ''}`}>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <strong>{label}</strong>
        <Button small variant="subtle" onClick={onRemove} title={he.publications.outletRemove}>×</Button>
      </div>

      <div className="row" style={{ gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
        <DateControl
          label={he.publications.outletRanOn}
          value={outlet.ran_on || ''}
          onChange={set('ran_on')}
          title={he.publications.outletRanOnHint}
        />
        <input
          type="url"
          value={outlet.url || ''}
          onChange={set('url')}
          placeholder={he.publications.outletUrl}
        />
      </div>

      {/* The clipping slot. Empty reads as a to-do, which is the point: the grid of
          cards is really a checklist of which papers we still lack a cutting for. */}
      <div className="clipping-slot">
        {clipping ? (
          <div className="row" style={{ gap: 4, flexWrap: 'wrap' }}>
            <span className="file-name" title={clipping.original_name}>{clipping.original_name}</span>
            <FileActions file={clipping} onRemove={onRemoveClipping} />
          </div>
        ) : canAttach ? (
          <label className="clipping-empty">
            <span>{he.publications.clippingAdd}</span>
            <input type="file" onChange={pick} disabled={busy} hidden />
          </label>
        ) : (
          <span className="muted">{he.publications.saveFirst}</span>
        )}
      </div>
    </div>
  );
}
